import Axios from 'axios';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import getMetaTagData from '../../../../src/common/services/getMetaTagData';
import ServiceNotice from '../../../../src/component/m/pass/ServiceNotice';

import cookieCutter from 'cookie-cutter';
import { toStringByDateFormat } from "../../../../src/common/utils/dateUtil";
import { getLnbList, isAndroid, isIOS } from "../../../../src/common/utils/passUtil";
import PointGroup from "../../../../src/component/m/pass/point/pointGroup";
import SlideBanner from "../../../../src/component/m/pass/SlideBanner";

function Point({ metaTagData, pointData, isAndroid, isSbsApp, lang, topEventBannerData }) {

  //jwt 토큰 관리
  const [login_jwt, setLogin_jwt] = useState();
  const [platform, setPlatform] = useState();
  const [sbs_id, setLogin_Id] = useState();
  const [isFoldBannerOpen, setIsFoldBannerOpen] = useState(false);
  const [isSbsAppState, setIsSbsAppState] = useState(isSbsApp);

  const [paddingTop, setPaddingTop] = useState('0px');

  useEffect(() => {
    if (isSbsAppState) {
      setPaddingTop('50px');
    } else {
      setPaddingTop('0px');
    }
  }, [isSbsAppState]);


  //화면시작시 최초 한번 시작...
  useEffect(async () => {
    window.scrollTo(0, 0);
    const LOGIN_JWT = cookieCutter.get('LOGIN_JWT'); //로그인 토큰 가져오는 부분
    const platformCookie = cookieCutter.get('JOIN_PLATFORM');
    const SBS_ID = cookieCutter.get('SBS_USER_ID');

    setLogin_jwt(LOGIN_JWT);
    setPlatform(platformCookie);
    setLogin_Id(SBS_ID);

  }, []);

  const foldBannerOpenToggleHandler = () => {
    if (isFoldBannerOpen) {
      setIsFoldBannerOpen(false);
    } else {
      setIsFoldBannerOpen(true);
    }
  };

  const eventStyle = isFoldBannerOpen ? {
    transition: "",
    transform: "",
    WebkitTransition: "height .3s ease",
    height: "100%",
    display: "block"
  } : {
    transition: "",
    transform: "",
    WebkitTransition: "",
    height: "",
    display: "none"
  }

  return (
    <>
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_M_PASSMONEY_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />
        <script src='//developers.kakao.com/sdk/js/kakao.min.js' />
        <meta name='description' content={metaTagData.shareDescription} />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={metaTagData.shareTitle || ''} />
        <meta property='og:description' content={metaTagData.shareDescription || ''} />8
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents">
        <div className="passmoneyContents" style={{ paddingTop }}>{/* 페이지 명 클래스  */}
          {isSbsApp && getLnbList('app')}
          <div className="passmoneyCont_point">
            {/* 스와이퍼 배너영역 */}

            {(lang == 'ko' || lang == '') && topEventBannerData && (
              (isSbsApp && !isAndroid) || !isSbsApp ? (
                <SlideBanner data={topEventBannerData} />
              ) : null
            )}

            <div className="pointContents">
              <div className="pointTopBnr">
                <strong className="title">
                  {lang === 'en' ? (
                    <>
                      You can purchase coupons <br />using S Points.
                    </>
                  ) : (
                    <>
                      S포인트를 이용해서<br />쿠폰을 구매할 수 있어요
                    </>
                  )}
                </strong>
                <img className="img" src="/images/pass/m/point_top_info01.png" alt="쿠폰이미지" />
              </div>
              {pointData.point_group && (<PointGroup data={pointData.point_group} loginJwt={login_jwt} lang={lang} />)}
            </div>
            <div className="pointInfoWrap">
              <div className="pointTitle">
                <>
                  {lang === 'en' ? (
                    <>
                      <strong className="title_id">{sbs_id ? sbs_id : 'Customer'}</strong>
                      <br />
                      <em className="title_text">I'll tell you how to get points</em>!
                    </>
                  ) : (
                    <>
                      <strong className="title_id">{sbs_id ? sbs_id : '고객'}</strong>님
                      <br />
                      <em className="title_text">S포인트 받는 방법</em> 알려드릴게요!
                    </>
                  )}
                  <i className="bg"><img src="/images/pass/m/pointBg01.png" alt="" /></i>
                </>
              </div>
              <ul className="pointInfoList">
                <li className="pointInfoItem item01">
                  <div className="pointInfoBox">
                    <i className="img"><img src="/images/pass/m/point_info01.png" /></i>
                    <strong className="title">
                      {lang === 'en' ? (
                        <>
                          <em className="number">Up to 1,000P</em> for watching VOD ads
                        </>
                      ) : (
                        <>
                          광고 보고 최대 <em className="number">1,000P</em>
                        </>
                      )}
                    </strong>

                    <p className="subText">{lang === 'en' ? 'Earn points every time you watch a 15-second video or ad after logging in. (Up to 1,000 points per day)' : '로그인 후 15초 영상과 광고를 시청할 때마다 적립돼요. (하루 최대 1,000P)'}</p>
                  </div>
                </li>
                <li className="pointInfoItem item02">
                  <div className="pointInfoBox">
                    <i className="img"><img src="/images/pass/m/point_info02.png" /></i>
                    <strong className="title">
                      {lang === 'en' ? (
                        <>
                          <em className="number">Up to 1,000P</em>  with badge missions
                        </>
                      ) : (
                        <>
                          뱃지 미션으로 최대 <em className="number">1,000P</em>
                        </>
                      )}
                    </strong>
                    <p className="subText">{lang === 'en' ? 'You can receive up to 1,000P by completing badge missions available in the app!' : '앱에서 참여 가능한 뱃지 미션 달성 시 최대 1,000P 받을 수 있다고!'}</p>
                  </div>
                </li>
                <li className="pointInfoItem item03">
                  <div className="pointInfoBox">
                    <i className="img"><img src="/images/pass/m/point_info03.png" /></i>
                    <strong className="title">
                      {lang === 'en' ? 'Participate in the event and get up to ' :
                        '이벤트 참여하고 최대'
                      }
                      <em className="number">10,000P</em>
                    </strong>
                    <p className="subText">{lang === 'en' ? 'Earn points every day by participating in the Roulette Event and Star Attendance Check Event!' : '룰렛 이벤트, 스타 출첵 이벤트 참여 시 매일매일 S포인트 지급!'}</p>
                  </div>
                </li>
              </ul>
            </div>
            {pointData.service_notice && (<div className="noticeList_wrap"><ServiceNotice data={pointData.service_notice}></ServiceNotice></div>)}
            <div className="contents_bottom_ad">
              <div className="bottom_ad_inner">
                <iframe title='배너광고' display='block' src='/html/m/point.htm' width='300px' height='250px' scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const getPointData = async (lang) => {
  let result = null;

  try {
    const apiUrl = lang == 'ko' ? process.env.NEXT_PUBLIC_API_POINT_KO : process.env.NEXT_PUBLIC_API_POINT_EN;
    const pointData = await Axios.get(apiUrl, { timeout: 3000 });
    result = pointData.data ? { ...pointData.data } : null;
    //console.log(lang);
    //console.log(result);

  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

const getTopEventBanner = async () => {
  let result = null;

  try {
    const today = toStringByDateFormat(new Date);

    const topEventBannerData = await Axios.get(process.env.NEXT_PUBLIC_API_TOP_EVENT_BANNER_POINT, { timeout: 3000 });

    result = topEventBannerData.data ? { ...topEventBannerData.data } : null;
    result = result.top_event_banner.filter(topEventBanner => topEventBanner.start_date <= today && topEventBanner.end_date >= today)

  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

export async function getServerSideProps(ctx) {
  //console.log('getServerSideProps');
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;
  const { JOIN_PLATFORM } = cookies;
  const { pageSection, pageCategory, lang = 'ko' } = ctx.query;

  let metaTagData;
  let pointData;
  let topEventBannerData;

  try {
    metaTagData = getMetaTagData(ctx.req.url, 'point', pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함)
    pointData = await getPointData(lang);
    topEventBannerData = await getTopEventBanner();
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      pointData: pointData,
      metaTagData,
      lang,
      topEventBannerData: topEventBannerData
    }
  };
}

export default Point;